import React, { ReactNode } from "react";
import styles from "./PlaydateInviteBaseView.module.css";
import Layout from "../../layout/Layout";
import happyFaceIcon from "../../../assets/icons/happyFace.svg";
import alertIcon from "../../../assets/icons/warning.svg";
import sadIcon from "../../../assets/icons/sadIcon.svg";

export type PlaydateInviteBaseViewProps = {
    onBack: () => void;
    title: string;
    baseZIndex?: number;
    children?: ReactNode;
    topIcon?: 'happy' | 'alert' | 'sad';
    infoText: string;
    useSectionDivider?: boolean;
};

const PlaydateInviteBaseView: React.FC<PlaydateInviteBaseViewProps> = ({
    onBack,
    title,
    baseZIndex,
    children,
    topIcon,
    infoText,
    useSectionDivider = true,
}) => {

    let icon: ReactNode;
    switch (topIcon) {
        case 'alert':
            icon = (
                <div className={styles.warningIconWrapper}>
                    <img src={alertIcon} className={styles.warningIcon} />
                </div>
            );
            break;
        case 'happy':
            icon = (
                <img src={happyFaceIcon} className={styles.confirmationIcon} />
            );
            break;
        case 'sad':
            icon = (
                <img src={sadIcon} className={styles.confirmationIcon} />
            );
            break;
    }

    return (
        <Layout
            navbarConfig={{
                title: title,
                onBack: onBack,
            }}
            containerConfig={{
                removeTopPadding: true,
            }}
            baseZIndex={baseZIndex}
        >
            <div className={`${styles.wrapperContainer}`}>
                <div className={styles.sheet}>
                    <div className={styles.iconContainer}>
                        {icon}
                    </div>
                    <div className={`${styles.infoSection} ${!useSectionDivider ? styles.noDivider : ''}`}>
                        {infoText}
                    </div>
                    {children}
                </div>
            </div>
        </Layout >
    );
};

export default PlaydateInviteBaseView;
